import {
  Box,
  CircularProgress,
  Divider,
  Pagination,
  Stack,
  Typography,
} from "@mui/material";

import { SupplierShipmentPreview } from "../SupplierShipmentPreview";
import { SupplierShipmentsEmptyState } from "../SupplierShipmentsEmptyState";

interface Props {
  supplierShipments: SupplierShipment[];
  error: string | null;
  isLoading: boolean;
  handlePageSelected: (e: React.ChangeEvent<unknown>, value: number) => void;
  page: number;
  pages: number;
}

export function SupplierShipmentsList(props: Props) {
  const {
    supplierShipments,
    error,
    isLoading,
    page,
    pages,
    handlePageSelected,
  } = props;

  if (isLoading) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (error != null) {
    return (
      <Stack mb="1em" alignItems="center">
        <Typography color="red">{error}</Typography>
      </Stack>
    );
  }

  if (supplierShipments.length === 0) {
    return <SupplierShipmentsEmptyState />;
  }

  return (
    <Stack>
      {supplierShipments.map((shipment) => (
        <Box key={shipment.info.id}>
          <Divider style={{ margin: "0" }} />
          <SupplierShipmentPreview supplierShipment={shipment} />
        </Box>
      ))}
      <Divider />
      <Box my="1rem" display="flex" alignItems="center" justifyContent="center">
        <Pagination count={pages} onChange={handlePageSelected} page={page} />
      </Box>
    </Stack>
  );
}
